import { VerticalData } from './vertical';

export const ftaMediaTypeData = [
  {
    name: 'Digital Overall',
    lowerQuartile: '11.3%',
    median: '22.2%',
    upperQuartile: '34.6%',
  },
  {
    name: 'TV',
    lowerQuartile: '13.9%',
    median: '22.4%',
    upperQuartile: '29.6%',
  },
  {
    name: 'OOH',
    lowerQuartile: '30.5%',
    median: '67.9%',
    upperQuartile: '100.4%',
  },
] as const satisfies readonly VerticalData[];

export const ftaDigitalVerticalData = [
  {
    name: 'Audio',
    lowerQuartile: '3.8%',
    median: '8.2%',
    upperQuartile: '16.9%',
  },
  {
    name: 'Auto',
    lowerQuartile: '17.4%',
    median: '34.4%',
    upperQuartile: '53.5%',
  },
  {
    name: 'Dining',
    lowerQuartile: '13.7%',
    median: '22.7%',
    upperQuartile: '32.7%',
  },
  {
    name: 'Entertainment',
    lowerQuartile: '5.7%',
    median: '29.3%',
    upperQuartile: '48.2%',
  },
  {
    name: 'Finance*',
    lowerQuartile: '0.0%',
    median: '21.6%',
    upperQuartile: '27.7%',
  },
  {
    name: 'Pharma*',
    lowerQuartile: '1.5%',
    median: '9.9%',
    upperQuartile: '18.9%',
  },
  {
    name: 'Retail',
    lowerQuartile: '10.1%',
    median: '21.9%',
    upperQuartile: '37.1%',
  },
  {
    name: 'Telecom*',
    lowerQuartile: '0.3%',
    median: '9.6%',
    upperQuartile: '24.6%',
  },
  {
    name: 'Travel*',
    lowerQuartile: '6.2%',
    median: '24.2%',
    upperQuartile: '38.3%',
  },
] as const satisfies readonly VerticalData[];

export const ftaDigitalSubverticalData = [
  {
    name: 'Dining - Fast Casual',
    lowerQuartile: '11.7%',
    median: '23.0%',
    upperQuartile: '33.3%',
  },
  {
    name: 'Dining - QSR',
    lowerQuartile: '14.1%',
    median: '22.6%',
    upperQuartile: '32.2%',
  },
  {
    name: 'Entertainment',
    lowerQuartile: '5.7%',
    median: '29.3%',
    upperQuartile: '48.2%',
  },
  {
    name: 'Retail - Alc Bev',
    lowerQuartile: '9.6%',
    median: '19.3%',
    upperQuartile: '26.3%',
  },
  {
    name: 'Retail - Appliances*',
    lowerQuartile: '0.6%',
    median: '12.2%',
    upperQuartile: '25.8%',
  },
  {
    name: 'Retail - Automotive',
    lowerQuartile: '17.4%',
    median: '34.4%',
    upperQuartile: '53.5%',
  },
  {
    name: 'Retail - Beauty',
    lowerQuartile: '19.3%',
    median: '30.2%',
    upperQuartile: '42.7%',
  },
  {
    name: 'Retail - Big Box',
    lowerQuartile: '13.5%',
    median: '23.6%',
    upperQuartile: '35.1%',
  },
  {
    name: 'Retail - Clothing',
    lowerQuartile: '13.8%',
    median: '27.5%',
    upperQuartile: '47.6%',
  },
  {
    name: 'Retail - Convenience',
    lowerQuartile: '5.8%',
    median: '16.0%',
    upperQuartile: '28.8%',
  },
  {
    name: 'Retail - Drug',
    lowerQuartile: '13.0%',
    median: '20.8%',
    upperQuartile: '37.7%',
  },
  {
    name: 'Retail - Furniture',
    lowerQuartile: '2.3%',
    median: '14.2%',
    upperQuartile: '34.4%',
  },
  {
    name: 'Retail - Grocery',
    lowerQuartile: '11.5%',
    median: '21.8%',
    upperQuartile: '31.4%',
  },
  {
    name: 'Retail - Home Improvement',
    lowerQuartile: '6.3%',
    median: '17.3%',
    upperQuartile: '35.5%',
  },
  {
    name: 'Retail - Pet*',
    lowerQuartile: '20.3%',
    median: '28.5%',
    upperQuartile: '41.9%',
  },
  {
    name: 'Retail - Sporting Goods*',
    lowerQuartile: '27.3%',
    median: '32.8%',
    upperQuartile: '45.1%',
  },
] as const satisfies readonly VerticalData[];

export const ftaTvVerticalData = [
  {
    name: 'Dining',
    lowerQuartile: '13.4%',
    median: '21.5%',
    upperQuartile: '29.4%',
  },
  {
    name: 'Retail',
    lowerQuartile: '17.9%',
    median: '24.5%',
    upperQuartile: '31.1%',
  },
] as const satisfies readonly VerticalData[];

export const ftaTvSubverticalData = [
  {
    name: 'Dining - Fast Casual*',
    lowerQuartile: '9.3%',
    median: '19.8%',
    upperQuartile: '28.0%',
  },
  {
    name: 'Dining - QSR',
    lowerQuartile: '16.6%',
    median: '25.1%',
    upperQuartile: '30.4%',
  },
  {
    name: 'Retail - Home Improvement*',
    lowerQuartile: '17.3%',
    median: '25.1%',
    upperQuartile: '33.1%',
  },
] as const satisfies readonly VerticalData[];

export const ftaOohVerticalData = [
  {
    name: 'Dining',
    lowerQuartile: '35.1%',
    median: '60.9%',
    upperQuartile: '100.8%',
  },
  {
    name: 'Retail',
    lowerQuartile: '25.1%',
    median: '76.2%',
    upperQuartile: '100.5%',
  },
  {
    name: 'Automotive*',
    lowerQuartile: '36.3%',
    median: '69.4%',
    upperQuartile: '82.8%',
  },
] as const satisfies readonly VerticalData[];

export const ftaOohSubverticalData = [
  {
    name: 'Dining - Fast Casual*',
    lowerQuartile: '68.2%',
    median: '101.6%',
    upperQuartile: '146.0%',
  },
  {
    name: 'Dining - QSR*',
    lowerQuartile: '26.9%',
    median: '47.8%',
    upperQuartile: '79.7%',
  },
  {
    name: 'Retail - Clothing*',
    lowerQuartile: '64.7%',
    median: '100.2%',
    upperQuartile: '131.0%',
  },
] as const satisfies readonly VerticalData[];
